import React, {memo} from 'react';

import {buildCatalogMap} from '../../lib/catalog';
import BarChart from '../BarChart';

function CatalogWidget({answers, catalog, question}) {
  const catalogMap = buildCatalogMap(catalog);

  const answersByCatalog = answers.reduce((map, answer) => {
    if(!map[answer.value]) {
      map[answer.value] = [];
    }

    map[answer.value].push(answer);
    return map;
  }, {});
  const data = Object.keys(answersByCatalog).map((key, i) => ({
    name: key.split(',').map(id => catalogMap[id.trim()] ? catalogMap[id.trim()].name : '(deleted)').join(' → '),
    index: i + 1,
    value: answersByCatalog[key].length
  }));

  return (
    <BarChart title={question.text ? question.text : ''} data={data} total={answers.length} question={question} />
  );
};

export default memo(CatalogWidget);
